import { createModulePage } from '../../components/generic/createModulePage';
import { initializeModule } from '../../utils/configInit';
import { trainingAssignmentConfig } from './trainingAssignmentConfig';
import { createTrainingAssignmentValidationSchema } from './trainingAssignmentValidation';

/**
 * Initialize the TrainingAssignment module using generic utilities
 */
const { config: initializedConfig } = initializeModule(
  trainingAssignmentConfig,
  createTrainingAssignmentValidationSchema
);

/**
 * Create the TrainingAssignmentPage using the generic module page factory
 */
const TrainingAssignmentPage = createModulePage(
  initializedConfig,
  {
    displayName: 'TrainingAssignmentPage',
    description: 'Training Assignment Management System - Training compliance and tracking'
  }
);

export default TrainingAssignmentPage;
